export const CURRENCY_CONFIG = [
    {
        type: 'dbits',
        rate: 0.0000001
    },
    {
        type: 'XDB',
        rate: 1
    },
    {
        type: 'USD',
        rate: 0.01
    },
    {
        type: 'EUR',
        rate: 0.008
    },
    {
        type: 'CAD',
        rate: 0.01333333333333333
    },
    {
        type: 'BTC',
        rate: 0.00000116289
    },
]


// WEBPACK FOOTER //
// ./src/components/money.js